<template>
  <div class="checkout">
    <h2>Assinar Plano Premium</h2>

    <!-- <div class="form-group">
      <label>Método de Pagamento:</label>
      <select v-model="metodo">
        <option value="credit_card">Cartão de Crédito</option>
        <option value="boleto">Boleto</option>
        <option value="pix">Pix</option>
      </select>
    </div>

    <div v-if="metodo === 'credit_card'" class="form-group card-fields">
      <input v-model="card.nome" placeholder="Nome no cartão" />
      <input v-model="card.numero" placeholder="Número do cartão" maxlength="19" />
      <div class="inline-fields">
        <input v-model="card.expiracao" placeholder="MM/AA" maxlength="5" />
        <input v-model="card.cvc" placeholder="CVC" maxlength="4" />
      </div>
      <label class="salvar-cartao">
        <input type="checkbox" v-model="salvar" />
        Salvar cartão para futuras compras
      </label>
    </div>

    <button class="btn-pagar" @click="finalizarCompra">Pagar</button>

    <div v-if="transacao" class="resultado">
      <h3>Status: <span class="status">{{ transacao.status }}</span></h3>

      <div v-if="metodo === 'pix'" class="info-pagamento">
        <label>Pix Copia e Cola:</label>
        <textarea :value="transacao.pix_qr_code" readonly></textarea>
      </div>

      <div v-if="metodo === 'boleto'" class="info-pagamento">
        <label>Boleto:</label>
        <input :value="transacao.boleto_barcode" readonly />
        <p><a :href="transacao.boleto_url" target="_blank">Abrir Boleto</a></p>
      </div>
    </div>

    <div v-if="erro" class="erro">
      {{ erro }}
    </div> -->

    <div class="container">
      <h4>Escolha a forma de pagamento</h4>
      <div style="padding-top: 30px;" class="row">
        <button @click.prevent="mtdforma(1)" :class="!mostracartao ? 'btn primary' : 'btn info'" type="button">
          <span>Cartão de crédito</span>
          <span><i :class="!mostracartao ? 'bi bi-chevron-double-down' : 'bi bi-chevron-double-up'"></i></span>
        </button>
      </div>
      <div v-show="mostracartao" class="row">
        <div class="form-group card-fields">
          <input v-model="card.nome" placeholder="Nome no cartão" />
          <input v-model="card.numero" placeholder="Número do cartão" maxlength="19" />
          <div class="inline-fields">
            <input v-model="card.expiracao" placeholder="MM/AA" maxlength="5" />
            <input v-model="card.cvc" placeholder="CVC" maxlength="4" />
          </div>
          <label class="salvar-cartao">
            <input type="checkbox" v-model="salvar" />
            Salvar cartão para futuras compras
          </label>
        </div>

      </div>


      <div style="padding-top: 30px;" class="row">
        <button @click.prevent="mtdforma(2)" :class="!mostrapix ? 'btn primary' : 'btn info'" type="button">
          <span>Pix</span>
          <span><i :class="!mostrapix ? 'bi bi-chevron-double-down' : 'bi bi-chevron-double-up'"></i></span>
        </button>
      </div>
      <div v-show="mostrapix" class="row">

      </div>


      <div style="padding-top: 30px;" class="row">
        <button @click.prevent="mtdforma(3)" :class="!mostraboleto ? 'btn primary' : 'btn info'" type="button">
          <span>Boleto</span>
          <span><i :class="!mostrafiltro ? 'bi bi-chevron-double-down' : 'bi bi-chevron-double-up'"></i></span>
        </button>
      </div>
      <div v-show="mostrafiltro" class="row">

      </div>


    </div>


  </div>
</template>

<script>
/* eslint-disable */
import util from './util.js';
export default {
  data() {
    return {
      metodo: 'credit_card',
      salvar: false,
      card: {
        nome: '',
        numero: '',
        expiracao: '',
        cvc: ''
      },
      transacao: null,
      erro: null,

      mostracartao: false,
      mostrapix: false,
      mostraboleto: false,

      //dados para exibir boleto


      //dados parra exibir pix

    };
  },
  methods: {
    mtdforma(forma) {
      this.mostracartao = false;
      this.mostrapix = false;
      this.mostraboleto = false;
      switch (forma) {
        case 1:
          this.mostracartao = true;
          break;
        case 2:
          this.mostrapix    = true;
          break;
        case 3:
          this.mostraboleto = true;
          break;


      }

    },
    preparapulin(dados) {
      let vself = this


    },
    finalizarCompra() {
      const vself = this;

      let parametros = [
        { parametro: 'op', valor: 'finalizarcompra' },
        { parametro: 'metodo', valor: vself.metodo },
        { parametro: 'idusuario', valor: localStorage.getItem('iduser') },
        { parametro: 'salvar', valor: vself.salvar ? '1' : '0' }
      ];

      if (vself.metodo === 'credit_card') {
        parametros.push({ parametro: 'card', valor: JSON.stringify(vself.card) });
      }

      let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/finalizar-compra.php');

      retorno.then(function (response) {
        if ($.isNumeric(response.data.inf)) {
          vself.preparapulin(response.data);
        } else {
          vself.erro = response.data.inf;
        }

      }).catch(function () {
        vself.erro = 'Erro de comunicação com o servidor.';
        vself.transacao = null;
      });
    }
  }
};
</script>

<style scoped>
.checkout {
  max-width: 600px;
  margin: 40px auto;
  padding: 25px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: #f9f9f9;
  font-family: Arial, sans-serif;
}

h2 {
  text-align: center;
  margin-bottom: 20px;
  color: #333;
}

.form-group {
  margin-bottom: 20px;
}

input,
select,
textarea {
  width: 100%;
  padding: 10px;
  margin-top: 8px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.inline-fields {
  display: flex;
  gap: 10px;
}

.inline-fields input {
  flex: 1;
}

.salvar-cartao {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
}

.btn-pagar {
  width: 100%;
  padding: 12px;
  background-color: #28a745;
  color: white;
  border: none;
  font-weight: bold;
  border-radius: 5px;
  cursor: pointer;
}

.btn-pagar:hover {
  background-color: #218838;
}

.resultado {
  margin-top: 20px;
  padding: 15px;
  background-color: #e9f7ef;
  border: 1px solid #c3e6cb;
  border-radius: 6px;
}

.status {
  text-transform: capitalize;
  font-weight: bold;
  color: #155724;
}

.info-pagamento label {
  font-weight: bold;
  display: block;
  margin-top: 10px;
}

textarea {
  resize: none;
  height: 80px;
}

.erro {
  margin-top: 20px;
  color: #dc3545;
  background: #f8d7da;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #f5c6cb;
}
</style>
